import { acceptanceDateField } from '../../../shared/cards/complianceUpstreamFields';
import type { CoverSheetConfigCard } from '../../../types';

export const importantDatesCard = {
  id: 'propertyInfo.importantDates',
  innerTitle: 'Important Listing Dates',
  legend: '',
  layout: [
    [
      {
        name: 'contractDate',
        size: 33,
      },
      {
        name: 'listingStartDate',
        size: 33,
      },
      {
        name: 'listingEndDate',
        size: 33,
      },
    ],
    [{ name: 'acceptanceDate', size: 33 }],
  ],
  fields: {
    contractDate: {
      name: 'contractDate',
      entity: 'interaction',
      type: 'date',
      label: 'Contract Date',
      placeholderText: '',
    },
    listingStartDate: {
      name: 'listingStartDate',
      entity: 'interaction',
      type: 'date',
      label: 'Listing Start Date',
      placeholderText: '',
    },
    listingEndDate: {
      name: 'listingEndDate',
      entity: 'interaction',
      type: 'date',
      label: 'Listing End Date',
      placeholderText: '',
    },
    acceptanceDate: acceptanceDateField,
  },
} satisfies CoverSheetConfigCard;
